import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { Chip as ChipMUI } from "@mui/material";

const Chip: FC<Props> = ({
  element,
  avatar,
  icon,
  onDelete,
  small = false,
  outlined = false,
  onClick,
  error = false,
  background,
  color,
}) => {
  return (
    <ChipMUI
      sx={{ background: background, color: color }}
      onClick={onClick}
      variant={outlined ? "outlined" : "filled"}
      avatar={avatar}
      icon={icon}
      size={small ? "small" : "medium"}
      color={error ? "error" : "secondary"}
      className={`${styles.tag}`}
      label={element}
      onDelete={onDelete}
    />
  );
};

export default Chip;
